import { ColumnConfig, ColumnConfigOptions, ColumnText, DateFormatter, LodashSeriesEnricherMapper, NumberFormatter, SimplePortfolioExtractorConfig, StoreLodashExtractor, StoreNestedFilterExtractor, TabConfig, TablePerPortfolioSeriesExtractorConfig } from '@ddt-web/data-service';
import { DateUtil } from '@ddt-web/generic-utils';

import { FAMILY_PERFORMANCE_COLUMN_CONFIG, MODEL_PORTFOLIO_FILTER_FUNCTION, MODEL_SHORT_NAME_COLUMN } from './family-column.config';

export const ESG_UPLIFT_SCORE = new TabConfig(
	'esgScore',
	null,
	new TablePerPortfolioSeriesExtractorConfig(
		new LodashSeriesEnricherMapper(
			['families', 'familyEsg'],
			['families', 'familyEsg'],
			'families.models',
			(portfolio: any, data: any) => {
				return {
					...portfolio,
					...data?.familyEsg?.models?.find(model => model?.id === portfolio.id) ?? []
				};
			},
			MODEL_PORTFOLIO_FILTER_FUNCTION
		),
		new ColumnText('MODEL', 'Model'),
		[
			// Need to update once ESG benchmark data is available
			ColumnConfig.create({
				id: 'esgScoreBenchmark',
				label: new ColumnText('ESG Score Benchmark', 'ESG Score Benchmark', null, { sortable: false, align: 'text-align-left' }),
				extractor: new StoreNestedFilterExtractor(
					['familyEsg'],
					'benchmarkEsgScores',
					[{ propertyToCompare: 'name', comparedValue: 'overallScore', desiredValueExpression: 'total' }]
				),
				labelFormatter: new NumberFormatter(NumberFormatter.PERCENT)
			} as ColumnConfigOptions<StoreNestedFilterExtractor>),
			ColumnConfig.create({
				id: 'esgScore',
				label: new ColumnText('ESG Score', 'ESG Score', null, { sortable: false, align: 'text-align-left' }),
				extractor: new StoreNestedFilterExtractor(
					['familyEsg'],
					'esgScores',
					[{ propertyToCompare: 'name', comparedValue: 'overallScore', desiredValueExpression: 'total' }]
				),
				labelFormatter: new NumberFormatter(NumberFormatter.PERCENT)
			} as ColumnConfigOptions<StoreNestedFilterExtractor>)
		],
		FAMILY_PERFORMANCE_COLUMN_CONFIG
	)
);

export const ESG_UPLIFT_CATEGORIES = new TabConfig(
	'esgUpliftModels',
	null,
	new TablePerPortfolioSeriesExtractorConfig(
		new LodashSeriesEnricherMapper(
			['families'],
			['families'],
			'families.models',
			(portfolio: any, data: any) => {
				return {
					...portfolio
				};
			},
			MODEL_PORTFOLIO_FILTER_FUNCTION
		),
		new ColumnText('MODEL', 'Model'),
		[MODEL_SHORT_NAME_COLUMN],
		FAMILY_PERFORMANCE_COLUMN_CONFIG
	)
);

export const ESG_AS_OF_DATE = new TabConfig(
	'asOfDate',
	new ColumnConfig(new ColumnText('AS_OF_DATE', 'As Of Date'), null, null, 'name'),
	new SimplePortfolioExtractorConfig(
		null,
		[
			new ColumnConfig(
				new ColumnText('asOfDate', 'As Of Date'),
				null,
				new StoreLodashExtractor(['familyEsg'], 'models[0].analysisDate'),
				null,
				new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT)
			)
		],
		FAMILY_PERFORMANCE_COLUMN_CONFIG
	)
);
